import { default as accordionTokens } from "./accordion.js";
export const { accordion } = accordionTokens.component;
import { default as alertTokens } from "./alert.js";
export const { alert } = alertTokens.component;
import { default as appBarTokens } from "./app-bar.js";
export const { appBar } = appBarTokens.component;
import { default as badgeTokens } from "./badge.js";
export const { badge } = badgeTokens.component;
import { default as buttonGroupTokens } from "./button-group.js";
export const { buttonGroup } = buttonGroupTokens.component;
import { default as buttonTokens } from "./button.js";
export const { button } = buttonTokens.component;
import { default as cardTokens } from "./card.js";
export const { card } = cardTokens.component;
import { default as checkboxTokens } from "./checkbox.js";
export const { checkbox } = checkboxTokens.component;
import { default as chipTokens } from "./chip.js";
export const { chip } = chipTokens.component;
import { default as datePickerTokens } from "./date-picker.js";
export const { datePicker } = datePickerTokens.component;
import { default as dropdownTokens } from "./dropdown.js";
export const { dropdown } = dropdownTokens.component;
import { default as formFieldTokens } from "./form-field.js";
export const { formField } = formFieldTokens.component;
import { default as inputTokens } from "./input.js";
export const { input } = inputTokens.component;
import { default as labelTokens } from "./label.js";
export const { label } = labelTokens.component;
import { default as linkTokens } from "./link.js";
export const { link } = linkTokens.component;
import { default as listItemTokens } from "./list-item.js";
export const { listItem } = listItemTokens.component;
import { default as loadingIndicatorTokens } from "./loading-indicator.js";
export const { loadingIndicator } = loadingIndicatorTokens.component;
import { default as menuTokens } from "./menu.js";
export const { menu } = menuTokens.component;
import { default as modalTokens } from "./modal.js";
export const { modal } = modalTokens.component;
import { default as paginationTokens } from "./pagination.js";
export const { pagination } = paginationTokens.component;
import { default as placeholderTokens } from "./placeholder.js";
export const { placeholder } = placeholderTokens.component;
import { default as radioButtonTokens } from "./radio-button.js";
export const { radioButton } = radioButtonTokens.component;
import { default as sideNavTokens } from "./side-nav.js";
export const { sideNav } = sideNavTokens.component;
import { default as sliderTokens } from "./slider.js";
export const { slider } = sliderTokens.component;
import { default as splitButtonTokens } from "./split-button.js";
export const { splitButton } = splitButtonTokens.component;
import { default as statusIndicatorTokens } from "./status-indicator.js";
export const { statusIndicator } = statusIndicatorTokens.component;
import { default as stepperTokens } from "./stepper.js";
export const { stepper } = stepperTokens.component;
import { default as tableTokens } from "./table.js";
export const { table } = tableTokens.component;
import { default as tabsTokens } from "./tabs.js";
export const { tabs } = tabsTokens.component;
import { default as tagTokens } from "./tag.js";
export const { tag } = tagTokens.component;
import { default as toastTokens } from "./toast.js";
export const { toast } = toastTokens.component;
import { default as toggleTokens } from "./toggle.js";
export const { toggle } = toggleTokens.component;
import { default as tooltipTokens } from "./tooltip.js";
export const { tooltip } = tooltipTokens.component;
